import { render, staticRenderFns } from "./Workbook.vue?vue&type=template&id=562500ef&"
import script from "./Workbook.vue?vue&type=script&lang=ts&"
export * from "./Workbook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports